import { c as _c } from "react/compiler-runtime";
import { HStack, Text } from '@chakra-ui/react';
import { TypingDots } from '@src/components/sco/Chat/TypingDots';
import { useAttachmentUserPresences } from '@src/hooks/useAttachmentUserPresences';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
type ChatTypingIndicatorProps = {
  attachmentType: string;
  attachmentId: string;
};
export const ChatTypingIndicator = props => {
  const $ = _c(14);
  const {
    currentUser
  } = useCurrentUser();
  const attachmentPresences = useAttachmentUserPresences(props.attachmentType, props.attachmentId);
  let t0;
  if ($[0] !== attachmentPresences) {
    t0 = Object.values(attachmentPresences).filter(_temp).map(_temp2);
    $[0] = attachmentPresences;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== currentUser?.userId || $[3] !== t0) {
    t1 = t0.filter(user => user.userId !== currentUser?.userId);
    $[2] = currentUser?.userId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const typingUsers = t1;
  if (typingUsers.length === 0) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  console.log({
    typingUsers
  });
  const t2 = typingUsers.length > 0 ? "3em" : "0";
  const t3 = typingUsers.length > 0 ? 1 : 0;
  const t4 = typingUsers.length ? "1em" : 0;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TypingDots />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== typingUsers) {
    t6 = typingUsers.length > 0 && <Text flexGrow={1}>{`${typingUsers.map(_temp3).join(" and ")} ${typingUsers.length === 1 ? "is" : "are"} typing.`}</Text>;
    $[7] = typingUsers;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <><HStack align="center" fontSize="12px" height={t2} opacity={t3} paddingY={t4} transition="all 250ms ease-in-out">{t5}{t6}</HStack></>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(presence) {
  return presence.isTyping && presence.user;
}
function _temp2(presence_0) {
  return presence_0.user;
}
function _temp3(u) {
  return u.fullName;
}